module.exports = __webpack_public_path__ + "static/img/Sualauvi-Faalogo.96470fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Sualauvi-Faalogo.jpg
// module id = HiAr
// module chunks = 0